import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#masonry-grid');
  const wrapper = document.querySelector('.show-more-wrapper');
  const toggleBtn = document.getElementById('show-more-btn');
  let expanded = false;
  let msnry;

  if (!grid || !toggleBtn) return;

  // Wait for all images to load
  imagesLoaded(grid, () => {
    msnry = new Masonry(grid, {
      itemSelector: '.masonry-item',
      percentPosition: true,
    });
  });

  toggleBtn.addEventListener('click', () => {
  const hiddenItems = document.querySelectorAll('#masonry-grid .masonry-item.hidden-extra');

  hiddenItems.forEach(item => {
    item.classList.toggle('d-none');
    item.classList.toggle('d-block');
  });

  expanded = !expanded;
  toggleBtn.textContent = expanded ? 'Zurück zum Anfang' : 'Mehr anzeigen';

  if (wrapper) {
    wrapper.classList.toggle('expanded', expanded);
  }

  if (msnry) {
    msnry.layout();
  }

  // Scroll to parent section when collapsing
  if (!expanded) {
    const parentSection = toggleBtn.closest('section');
    if (parentSection) {
      parentSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
});

});

